module.exports = __webpack_public_path__ + "static/media/24UHCHR1.4197a909.jpg";